export default __webpack_public_path__ + "static/banner-icon-7f1686ac047ae3ef133f7be2a2859a8a.png";